import BasicListItem from "./basic-list-item";

export default function BasicList({ items, navigatesTo }) {

    return <div className="cell small-12">
        <h4 className="margin__left--s basic-list__col-title">Name</h4>
        {items && items.map((item, i) => <BasicListItem id={item.id} name={item.name} isArchived={item.isArchived} key={i} to={navigatesTo} />)}
    </div>
}